'use client'

import Section8 from 'src/views/Section8'
import BenchmarkSection from './v2/components/BenchmarkSection'
import DeliveryIntelligenceSection from './v2/components/DeliveryIntelligenceSection'
import FeatureSection from './v2/components/FeatureSection'
import HeroSection from './v2/components/HeroSection'
import TestimonialsSection from './v2/components/TestimonialsSection'
import TrustProofSection from './v2/components/TrustProofSection'
import TrustedBySection from './v2/components/TrustedBySection'

// Main page component with mobile and desktop optimization
// Using only two breakpoints: mobile (default) and desktop (sm)
export default function Page() {
  return (
    <main className="min-h-screen">
      {/* Done ✅ */}
      <HeroSection />

      <TrustedBySection />
      {/* <VideoSection /> */}
      {/* Done ✅ */}
      <DeliveryIntelligenceSection />
      {/* Done ✅ */}
      <FeatureSection />

      {/* <ProductLook /> */}

      <TestimonialsSection />
      {/* <CaseStudySection /> */}
      {/* Done ✅ */}
      <TrustProofSection />
      {/* Done ✅ */}
      <BenchmarkSection />
      <Section8 />
    </main>
  )
}
